export default __webpack_public_path__ + "static/media/bg-image-2.e12a7844.jpg";